import {
  BooleanField,
  Datagrid,
  ReferenceField,
  TextField,
  TextInput,
  // SearchInput,
  SelectInput,
  useTranslate,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { DateField, RatingField } from '../../components/fields'
import { PRODUCT_REVIEWS_FIELDS } from '../../providers/localization/constant'

const AdminList = (): JSX.Element => {
  const translate = useTranslate()
  const adminListFilters = [
    <TextInput
      key={1}
      source='product_name'
      label={translate(`${PRODUCT_REVIEWS_FIELDS}.product.label`)}
    />,
    <SelectInput
      key={4}
      label={`${PRODUCT_REVIEWS_FIELDS}.product_group.label`}
      source='product_group'
      choices={[
        { id: 'tire', name: 'ยางรถยนต์' },
        { id: 'brake', name: 'เบรค' },
        { id: 'shock', name: 'โช็คอัพ' },
        { id: 'lubricant', name: 'น้ำมันเครื่อง' },
        { id: 'battery', name: 'แบตเตอรี่' },
        { id: 'other', name: 'อื่นๆ' },
      ]}
    />,
    <SelectInput
      key={5}
      label={`${PRODUCT_REVIEWS_FIELDS}.is_active.label`}
      source='is_active'
      choices={[
        { id: 'true', name: `${PRODUCT_REVIEWS_FIELDS}.is_active.choices.active` },
        { id: 'false', name: `${PRODUCT_REVIEWS_FIELDS}.is_active.choices.inActive` },
      ]}
    />,
  ]

  return (
    <ListBase perPage={50} filters={adminListFilters} sort={{ field: 'create_at', order: 'DESC' }}>
      <Datagrid rowClick='show' bulkActionButtons={null}>
        <RatingField source='score' label={`${PRODUCT_REVIEWS_FIELDS}.score.label`} />
        <TextField source='subject' label={`${PRODUCT_REVIEWS_FIELDS}.subject.label`} />
        <TextField
          source='message'
          label={`${PRODUCT_REVIEWS_FIELDS}.message.label`}
          sortable={false}
        />
        <TextField source='full_name' label={`${PRODUCT_REVIEWS_FIELDS}.full_name.label`} />
        <ReferenceField
          source='product_id'
          reference='products'
          label={`${PRODUCT_REVIEWS_FIELDS}.product.label`}
          sortBy='prod_name_th'
        >
          <TextField source='prod_name_th' />
        </ReferenceField>
        <ReferenceField
          source='product_id'
          reference='products'
          label={`${PRODUCT_REVIEWS_FIELDS}.product_group.label`}
          sortBy='product_type'
        >
          <TextField source='product_group_title_th' />
        </ReferenceField>
        <DateField
          source='create_at'
          showTime
          label={`${PRODUCT_REVIEWS_FIELDS}.create_at.label`}
          textAlign='center'
        />
        <BooleanField
          source='is_active'
          label={`${PRODUCT_REVIEWS_FIELDS}.is_active.label`}
          textAlign='center'
        />
      </Datagrid>
    </ListBase>
  )
}

export default AdminList
